<template>
  <div id="app" class="applica">
    <router-view :key="this.$route.path"></router-view>
    <ai-testcase-task-notifier></ai-testcase-task-notifier>
  </div>
</template>

<script>
  import AiTestcaseTaskNotifier from "./components/question/AiTestcaseTaskNotifier";

  export default {
    name: "App",
    components: {
      AiTestcaseTaskNotifier
    }
  };
</script>

<style lang="scss">
  @import "@/assets/scss/base.scss";
  #app{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue